import { render, staticRenderFns } from "./EmailSystem.vue?vue&type=template&id=151e6757&"
import script from "./EmailSystem.vue?vue&type=script&lang=ts&"
export * from "./EmailSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports